import * as R from 'ramda';
import OtherActivity from './otherActivity';


export default function Pension(data) {
    let activity = data || {};
    this.type = "Retraite";
    this.professionalCategory =  activity.professionalCategory;
    this.pensionBaseServiceId =  activity.pensionBaseServiceId;
    this.pensionComplementServiceId =  activity.pensionComplementServiceId;
    this.customPensionBase =  R.isNil(activity.customPensionBase) ? new OtherActivity() : new OtherActivity(activity.customPensionBase);
    this.customPensionComplement =  R.isNil(activity.customPensionComplement) ? new OtherActivity() : new OtherActivity(activity.customPensionComplement);
}